module.exports = __webpack_public_path__ + "static/media/wallis-and-futuna.52893ba7.svg";